import OfflinePackage from 'offline-js';
import config from './config';

const scope = typeof globalThis !== 'undefined'
	? globalThis
	: typeof window !== 'undefined'
		? window
		: typeof self !== 'undefined'
			? self
			: {};

const getOfflineModule = () => {
	if (OfflinePackage && typeof OfflinePackage === 'object' && OfflinePackage.default) return OfflinePackage.default;

	return OfflinePackage;
};

const getOfflineInstance = () => {
	const moduleCandidate = getOfflineModule();

	if (moduleCandidate) return moduleCandidate;

	if (typeof window !== 'undefined' && window.Offline) return window.Offline;

	return null;
};

const isBrowserOffline = () => typeof navigator !== 'undefined' && navigator.onLine === false;

const isOffline = () => {
	const offline = getOfflineInstance();

	if (!offline) return isBrowserOffline();

	if (typeof offline.state === 'string') return offline.state === 'down';

	if (typeof offline.isDown === 'function') return offline.isDown();

	if (typeof offline.isUp === 'function') return offline.isUp() === false;

	return isBrowserOffline();
};

const isPlainObject = value => Object.prototype.toString.call(value) === '[object Object]';

const mergeOptions = (target, source) => {
	if (!isPlainObject(source)) return target;

	const nextTarget = isPlainObject(target) ? target : {};

	Object.keys(source).forEach(key => {
		const sourceValue = source[key];

		if (isPlainObject(sourceValue)) {
			nextTarget[key] = mergeOptions(nextTarget[key], sourceValue);
			return;
		}

		nextTarget[key] = sourceValue;
	});

	return nextTarget;
};

const applyOfflineConfig = () => {
	const offline = getOfflineInstance();

	if (!offline) return false;

	const targetOptions = isPlainObject(offline.options) ? offline.options : {};

	offline.options = mergeOptions(targetOptions, config.offline || {});

	if (scope.Offline && scope.Offline !== offline) {
		scope.Offline.options = offline.options;
	}

	return true;
};

applyOfflineConfig();

export { getOfflineInstance, isOffline, applyOfflineConfig };
